import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";

function AddBookModal({ show, handleClose,tourName,appointment,setAppointment}) {

  const [name,setName]=useState("")
  const[date,setDate]=useState("")
  const [phone,setPhone]=useState("")
  


 const  handleSubmit=(e)=>{
    e.preventDefault()
    setAppointment([...appointment,{
      id:appointment.length +1,
      name: name,
      day:date,
      booked: false,
      tel:phone,
      tourname:tourName,
    }])


    handleClose()
  }
console.log(appointment);
  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Book For {tourName} </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="name">
              <Form.Label>Name</Form.Label>
              <Form.Control type="text" placeholder="Enter  your name" onChange={(e)=>setName(e.target.value)}/>
            </Form.Group>

            <Form.Group className="mb-3" controlId="phone">
              <Form.Label>Phone</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter your Phonenumber"
                onChange={(e)=>setPhone(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="date">
              <Form.Label>date</Form.Label>
              <Form.Control
                type="date"
                onChange={(e)=>setDate(e.target.value)}
               
              />
            </Form.Group>

            <div className="text-center ">
              <Button className="me-2 " variant="success" type="submit">
                Save
              </Button>
              <Button variant="danger" onClick={handleClose} >
                Close
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default AddBookModal;
